<template>
    <li class="sub-card-li">
      <a class="alp" :href="thumb.link" :target="sameDomain(thumb.link)? '_self' : '_blank'">
        <div class="thumb"><img :src="thumb.img" alt=""></div>
        <div class="desc">
          <h3 class="txt-overflow" ref="subTit">{{ thumb.title }}</h3>
        </div>
      </a>
    </li>
</template>


<style lang="scss" scoped>
.sub-card-li {
  @mixin flex($jc: space-between) {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    justify-content: $jc;
  }
  $concour: #00a8ff;
  $teaching: #f99709;
  $event: #2eb024;

  @include flex();
  a {
    display: block;
    background: #fff;
  }
  img {
    width: 100%;
  }

  @media only screen and (max-width: 750px) {
    display: block;
    width: 47.8%;
    margin-top: 4.4%;
    h3 {
      font-size: 0.8rem;
    }
  }
}

li {
  width: 48.41%;
  background: #fff;
  a {
    .desc {
      padding: 10px;
      line-height: 1.4;
      h3 {
        height: 2.8em;
      }
    }
  }
}
</style>

<script>
import $ from "jquery";
import _ from "lodash";
import imagesLoaded from "imagesloaded";
import ComponentUtils from "../../utils/ComponentUtils.js";

export default {
  props: ["thumb"],
  computed: {},
  mounted: function() {
    this.$nextTick(() => {
        imagesLoaded(this.$el, {}, this.imageLoadedDone);
    });
  },
  methods: _.assign(
    {
      txtOverflows() {
        this.txtOverflow($(this.$refs.mainTit));
        this.txtOverflow($(this.$refs.mainDesc));
        this.txtOverflow($(this.$refs.subTit));
      },
      imageLoadedDone() {
        this.txtOverflows();
        this.$nextTick(() => {
          this.txtOverflows();
          this.loaded = true;
          setTimeout(() => {
            this.txtOverflows();
          }, 10);
          setTimeout(() => {
            this.txtOverflows();
          }, 1100);
          setTimeout(() => {
            this.txtOverflows();
          }, 4000);
          setTimeout(() => {
            this.txtOverflows();
          }, 8000);
          $(window).resize(this.txtOverflows);
        });
      }
    },
    ComponentUtils
  )
};
</script>
